import { Flex } from "@eworkit/iris";
import React from "react";
import { useTranslation } from "react-i18next";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { EmptyText } from "@/components/EmptyText";
import { Group } from "@/components/Group";
import { Text } from "@/components/Text";
import { ICompanyContact } from "@/data/companies";

interface ISupplierContactSectionProps extends IEditableSectionRenderProps {
  contacts: ICompanyContact;
}

export const CompanyContactPreview = ({ contacts }: ISupplierContactSectionProps) => {
  const { t } = useTranslation("session");

  const getPhoneTextOrEmpty = (prefix: string | undefined, number: string | undefined) =>
    prefix?.trim() || number?.trim() ? `${prefix} ${number}` : <EmptyText />;

  return (
    <Flex flexDirection="column" gap={["sm", null, "sm"]}>
      <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.CONTACT.SUPPLIER_PHONE")} direction="column">
        <Text size="md" color="black">
          {getPhoneTextOrEmpty(contacts?.supplierContactPhonePrefix, contacts?.supplierContactPhone?.phoneNumber)}
        </Text>
      </Group>

      <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.CONTACT.SUPPLIER_EMAIL")} direction="column">
        <Text size="md" color="black">
          {contacts.supplierEmail || <EmptyText />}
        </Text>
      </Group>

      <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.CONTACT.FINANCE_PHONE")} direction="column">
        <Text size="md" color="black">
          {getPhoneTextOrEmpty(contacts?.financeContactPhonePrefix, contacts?.financeContactPhone?.phoneNumber)}
        </Text>
      </Group>

      <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.CONTACT.FINANCE_EMAIL")} direction="column">
        <Text size="md" color="black">
          {contacts.financeEmail || <EmptyText />}
        </Text>
      </Group>
    </Flex>
  );
};
